/* eslint-disable padding-line-between-statements */
import { InlineLoader } from '@jutro/components';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useTranslator } from '@jutro/locale';
import { pageTemplateProps } from '@xengage/gw-portals-wizard-react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {
    useCallback,
    useContext,
    useMemo,
} from 'react';

import WizardPageHeader from "producer-engage/src/overrides/modules-react/twia-portals-wizard-components-ui/Wizard/components/WizardPageHeader/WizardPageHeader.jsx"
import TWIAWizardSideMenu from '../components/TWIAWizardSideMenu/TWIAWizardSideMenu.jsx';
import styles from './TWIAWizardTemplate.module.scss';
import messages from '../common/TWIAWizardMessages.messages.js'

import { Button } from '@jutro/legacy/components';

function renderLoader(isLoading) {
    return isLoading ? (
        <InlineLoader loading={isLoading} className="gw-inline-loader" />
    ) : null;
}

function TWIAWizardTemplate(props) {
    const translator = useTranslator();
    const breakpoint = useContext(BreakpointTrackerContext);
    const isPhone = breakpoint === 'phoneWide' || breakpoint === 'phone';
    const {
        children: content,
        onNext,
        isLoadingNext,
        disableNext,
        showNext,
        nextLabel,
        onPrevious,
        isLoadingPrevious,
        disablePrevious,
        showPrevious,
        previousLabel,
        onCancel,
        isLoadingCancel,
        disableCancel,
        showCancel,
        cancelLabel,
        renderWidgets,
        wizardData,
        hideHeader,
        showSaveExit,
        isLoadingSave,
        onSaveAndExit,
        disableSaveExit
    } = props;

    const jobType = wizardData?.baseData?.jobType?.value?.code
    const wizardTitle = jobType === 'Renewal' ? messages.TWIARenewalTitle : messages.TWIAQuoteTitle

    const renderWizardHeader = useCallback(
        wizardData => {
            if (wizardData) {
                const getSubmissionVM = wizardData?.submissionVM || wizardData;

                return (
                    <WizardPageHeader
                        wizardSubmission={getSubmissionVM}

                    />
                );

            }

            return null

        },
        [wizardData]
    );



    const shouldShowButtons = useMemo(
        () =>
            !(
                showNext === false &&
                showPrevious === false &&
                showCancel === false
            ),
        [showCancel, showNext, showPrevious]
    );

    const isPerformingTransiton = useMemo(
        () => isLoadingCancel || isLoadingPrevious || isLoadingNext || isLoadingSave,
        [isLoadingCancel, isLoadingNext, isLoadingPrevious, isLoadingSave]
    );

    const buttonContainerClassName = classNames(styles.navTransitionButtons, {
        [styles.navTransitionButtonOnlyNext]: !showPrevious && isPhone,
    });

    const renderSideMenuHeader = () => {
        const jobType = _.get(wizardData, 'baseData.jobType.value')?.code;
        let headerMessage = '';

        switch (jobType) {
            case 'Submission':
                headerMessage = messages.TWIAQuoteTitle;
                break;
            case 'Renewal':
                headerMessage = messages.TWIARenewalTitle;
                break;
            case 'PolicyChange':
                headerMessage = messages.TWIAPolicyChangeTitle;
                break;
            default:
                break;
        }
        return headerMessage;
    }

    return (
        <div className={styles.digitalWizard}>
            <div className={styles.wizardMain}>
                {!isPhone ? (
                    <div
                        className={classNames(
                            styles.wizardNavigation,
                            'hiddenPrintElement'
                        )}
                    >
                        <TWIAWizardSideMenu
                            title={renderSideMenuHeader()}
                        />

                        <div className={styles.wizardWidgets}>

                            {renderWidgets(wizardData)}

                        </div>
                    </div>
                ) : null
                }
                <div className={styles.wizardContent}>
                    {!hideHeader ? renderWizardHeader(wizardData) : null}
                    {isPhone && <TWIAWizardSideMenu />}
                    {content}
                    <div
                        className={classNames(
                            { [styles.navButtons]: shouldShowButtons },
                            'hiddenPrintElement'
                        )}
                    >
                        <Button
                            id="gw-wizard-cancel"
                            disabled={
                                disableCancel || isPerformingTransiton
                            }
                            type="text"
                            onClick={onCancel}
                            // US26347 - Hiding cancel instead of removing it
                            className={showCancel ? styles.cancelButton : styles.hidecancel}
                        >
                            {translator(cancelLabel)}
                            {renderLoader(isLoadingCancel)}
                        </Button>
                        {(showPrevious && showSaveExit) && (
                            <Button
                                id="gw-wizard-previous"
                                disabled={
                                    disablePrevious ||
                                    isPerformingTransiton
                                }
                                className={classNames(styles.wizardButton)}
                                onClick={onPrevious}
                            >
                                {translator(previousLabel)}
                                {renderLoader(isLoadingPrevious)}
                            </Button>
                        )}
                            {showSaveExit && (
                                <Button
                                    id="gw-wizard-save"
                                    disabled={
                                        disablePrevious ||
                                        isPerformingTransiton ||
                                        disableSaveExit
                                    }
                                    className={classNames(styles.wizardButton)}
                                    onClick={onSaveAndExit}
                                >
                                    {translator(messages.saveAndExit)}
                                    {renderLoader(isLoadingSave)}
                                </Button>
                            )}
                            {(showNext && showSaveExit) && (
                                <Button
                                    id="gw-wizard-Next"
                                    className={classNames(styles.wizardButton)}
                                    disabled={disableNext || isPerformingTransiton}
                                    onClick={onNext}
                                >
                                    {translator(nextLabel)}
                                    {renderLoader(isLoadingNext)}
                                </Button>
                            )}
                        {!showSaveExit && <div className={buttonContainerClassName}>
                        {(showPrevious && !showSaveExit) && (
                            <Button
                                id="gw-wizard-previous"
                                disabled={
                                    disablePrevious ||
                                    isPerformingTransiton
                                }
                                className={classNames(styles.wizardButton, styles.previousbutton)}
                                onClick={onPrevious}
                            >
                                {translator(previousLabel)}
                                {renderLoader(isLoadingPrevious)}
                            </Button>
                        )}
                        {(showNext && !showSaveExit) && (
                            <Button
                                id="gw-wizard-Next"
                                className={classNames(styles.wizardButton, styles.nextbutton)}
                                disabled={disableNext || isPerformingTransiton}
                                onClick={onNext}
                            >
                                {translator(nextLabel)}
                                {renderLoader(isLoadingNext)}
                            </Button>
                        )}
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    );
}

TWIAWizardTemplate.propTypes = {
    ...pageTemplateProps,
    /** a function that accepts wizardData to render a React component */
    renderContextComponent: PropTypes.func,
    /** a function that accepts wizardData to render a React component */
    renderWidgets: PropTypes.func,
    showContextComponent: PropTypes.bool,
    showWizardHeader: PropTypes.bool,
    nextButtonTooltip: PropTypes.string,
};

TWIAWizardTemplate.defaultProps = {
    renderContextComponent: () => null,
    renderWidgets: () => null,
    showContextComponent: true,
    showWizardHeader: true,
    nextButtonTooltip: '',
};

export default TWIAWizardTemplate;
